import { Action } from "@ngrx/store";

export enum QuoteActionTypes {
  GET_QUOTE_LIST = "[Quotes] Get Quote List",
  GET_QUOTE_LIST_SUCCESS = "[Quotes] Get Quote List Success",
  GET_QUOTE_LIST_FAILURE = "[Quotes] Get Quote List Error",

  GET_CUSTOMER_QUOTE_LIST = "[Quotes] Get Customer Quote List",
  GET_CUSTOMER_QUOTE_LIST_SUCCESS = "[Quotes] Get Customer Quote List Success",
  GET_CUSTOMER_QUOTE_LIST_FAILURE = "[Quotes] Get Customer Quote List Error",

  GET_SALES_QUOTE_LIST = "[Quotes] Get Sales Quote List",
  GET_SALES_QUOTE_LIST_SUCCESS = "[Quotes] Get Sales Quote List Success",
  GET_SALES_QUOTE_LIST_FAILURE = "[Quotes] Get Sales Quote List Error",

  CLEAR_QUOTE_LIST = "[Quotes] Clear Quote List",

  GET_QUOTE = "[Quote] Get Quote by Id",
  GET_QUOTE_SUCCESS = "[Quote] Get Quote by Id Success",
  GET_QUOTE_FAILURE = "[Quote] Get Quote by Id Error",

  EMAIL_QUOTE = "[Quote] Email Quote by Id",
  EMAIL_QUOTE_SUCCESS = "[Quote] Email Quote by Id Success",
  EMAIL_QUOTE_FAILURE = "[Quote] Email Quote by Id Error",

  EMAIL_PURCHASE_QUOTE = "[Quote] Email Purchase Quote by Id",
  EMAIL_PURCHASE_QUOTE_SUCCESS = "[Quote] Email Purchase Quote by Id Success",
  EMAIL_PURCHASE_QUOTE_FAILURE = "[Quote] Email Purchase Quote by Id Error",
  
  EMAIL_REPORT = "[Quote] Email Report",
  EMAIL_REPORT_SUCCESS = "[Quote] Email Report Success",
  EMAIL_REPORT_FAILURE = "[Quote] Email Report Error",

  CREATE_RENTAL_QUOTE = "[Quote] Create Rental Quote",
  CREATE_RENTAL_QUOTE_SUCCESS = "[Quote] Create Rental Quote Success",
  CREATE_RENTAL_QUOTE_FAILURE = "[Quote] Create Rental Quote Error",

  CREATE_PURCHASE_QUOTE = "[Quote] Create Purchase Quote",
  CREATE_PURCHASE_QUOTE_SUCCESS = "[Quote] Create Purchase Quote Success",
  CREATE_PURCHASE_QUOTE_FAILURE = "[Quote] Create Purchase Quote Error",

  UPDATE_QUOTE = "[Quote] Update Quote",
  UPDATE_QUOTE_SUCCESS = "[Quote] Update Quote Success",
  UPDATE_QUOTE_FAILURE = "[Quote] Update Quote Failure",

  DOWNLOAD_QUOTE = "[Quote] Download Quote",
  DOWNLOAD_QUOTE_SUCCESS = "[Quote] Download Quote Success",
  DOWNLOAD_QUOTE_FAILURE = "[Quote] Download Quote Error",

  DOWNLOAD_PURCHASE_QUOTE = "[Quote] Download Purchase Quote",
  DOWNLOAD_PURCHASE_QUOTE_SUCCESS = "[Quote] Download Purchase Quote Success",
  DOWNLOAD_PURCHASE_QUOTE_FAILURE = "[Quote] Download Purchase Quote Error",
}

export class GetQuoteList implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE_LIST;
  constructor(public payload: any) { }
}

export class GetQuoteListSuccess implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuoteListFailure implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetCustomerQuoteList implements Action {
  readonly type = QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST;
  constructor(public payload: any) { }
}

export class GetCustomerQuoteListSuccess implements Action {
  readonly type = QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetCustomerQuoteListFailure implements Action {
  readonly type = QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetSalesQuoteList implements Action {
  readonly type = QuoteActionTypes.GET_SALES_QUOTE_LIST;
  constructor(public payload: any) { }
}

export class GetSalesQuoteListSuccess implements Action {
  readonly type = QuoteActionTypes.GET_SALES_QUOTE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetSalesQuoteListFailure implements Action {
  readonly type = QuoteActionTypes.GET_SALES_QUOTE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearQuoteList implements Action {
  readonly type = QuoteActionTypes.CLEAR_QUOTE_LIST;
  constructor() { }
}

export class GetQuote implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE;
  constructor(public id: any) { }
}

export class GetQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuoteFailure implements Action {
  readonly type = QuoteActionTypes.GET_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class EmailQuote implements Action {
  readonly type = QuoteActionTypes.EMAIL_QUOTE;
  constructor(public quoteId: any) { }
}

export class EmailQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.EMAIL_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class EmailQuoteFailure implements Action {
  readonly type = QuoteActionTypes.EMAIL_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class CreateRentalQuote implements Action {
  readonly type = QuoteActionTypes.CREATE_RENTAL_QUOTE;
  constructor(public payload: any) { }
}

export class CreateRentalQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.CREATE_RENTAL_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateRentalQuoteFailure implements Action {
  readonly type = QuoteActionTypes.CREATE_RENTAL_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class CreatePurchaseQuote implements Action {
  readonly type = QuoteActionTypes.CREATE_PURCHASE_QUOTE;
  constructor(public payload: any) { }
}

export class CreatePurchaseQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.CREATE_PURCHASE_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class CreatePurchaseQuoteFailure implements Action {
  readonly type = QuoteActionTypes.CREATE_PURCHASE_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateQuote implements Action {
  readonly type = QuoteActionTypes.UPDATE_QUOTE;
  constructor(public payload: any, public id: any) { }
}

export class UpdateQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.UPDATE_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateQuoteFailure implements Action {
  readonly type = QuoteActionTypes.UPDATE_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class DownloadQuote implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_QUOTE;
  constructor(public id: any) { }
}

export class DownloadQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class DownloadQuoteFailure implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class DownloadPurchaseQuote implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE;
  constructor(public id: any) { }
}

export class DownloadPurchaseQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE_SUCCESS;
  constructor(public payload: any) { }
}

export class DownloadPurchaseQuoteFailure implements Action {
  readonly type = QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE_FAILURE;
  constructor(public payload: any) { }
}

export class EmailPurchaseQuote implements Action {
  readonly type = QuoteActionTypes.EMAIL_PURCHASE_QUOTE;
  constructor(public quoteId: any) { }
}

export class EmailPurchaseQuoteSuccess implements Action {
  readonly type = QuoteActionTypes.EMAIL_PURCHASE_QUOTE_SUCCESS;
  constructor(public quoteId: any) { }
}

export class EmailPurchaseQuoteFailure implements Action {
  readonly type = QuoteActionTypes.EMAIL_PURCHASE_QUOTE_FAILURE;
  constructor(public quoteId: any) { }
}

export class EmailReport implements Action {
  readonly type = QuoteActionTypes.EMAIL_REPORT;
  constructor() { }
}

export class EmailReportSuccess implements Action {
  readonly type = QuoteActionTypes.EMAIL_REPORT_SUCCESS;
  constructor(public payload: any) { }
}

export class EmailReportFailure implements Action {
  readonly type = QuoteActionTypes.EMAIL_REPORT_FAILURE;
  constructor(public payload: any) { }
}

export type QuoteActions =
  | GetQuoteList
  | GetQuoteListSuccess
  | GetQuoteListFailure
  | GetCustomerQuoteList
  | GetCustomerQuoteListSuccess
  | GetCustomerQuoteListFailure
  | GetSalesQuoteList
  | GetSalesQuoteListSuccess
  | GetSalesQuoteListFailure
  | ClearQuoteList
  | GetQuote
  | GetQuoteSuccess
  | GetQuoteFailure
  | CreateRentalQuote
  | CreateRentalQuoteSuccess
  | CreateRentalQuoteFailure
  | CreatePurchaseQuote
  | CreatePurchaseQuoteSuccess
  | CreatePurchaseQuoteFailure
  | UpdateQuote
  | UpdateQuoteSuccess
  | UpdateQuoteFailure
  | DownloadQuote
  | DownloadQuoteSuccess
  | DownloadQuoteFailure
  | DownloadPurchaseQuote
  | DownloadPurchaseQuoteSuccess
  | DownloadPurchaseQuoteFailure
  | EmailPurchaseQuote
  | EmailPurchaseQuoteSuccess
  | EmailPurchaseQuoteFailure
  | EmailReport
  | EmailReportSuccess
  | EmailReportFailure
